














































import mixins from 'vue-typed-mixins';
import moment from 'moment';
import UserUtils, { User, UserDisplayList } from '@/utils/UserUtils';
import { DataTableHeader, DataTableCompareFunction } from 'vuetify';
export default mixins().extend({
  computed: {
    items(): UserDisplayList[] | undefined {
      moment.locale(this.$i18n.locale);
      const tempUsers = this.users?.map((user) => ({
        ...user,
        name: ((user.firstname||'')+' '+(user.lastname||'')).trim(),
        lastloginFromNow: (user.lastlogin ?
          moment(user.lastlogin).fromNow() : '')
      }));
      return tempUsers?.filter((user) => {
        if (this.inactive) {
          return true;
        } else {
          return user.state !== 'inactive';
        }
      });
    },

    headers(): DataTableHeader<User>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'name' },
        { text: this.$i18n.tc('model.user.username'), value: 'username' },
        {
          text: this.$i18n.tc('model.role.label', 2),
          value: 'roles',
          sortable: false,
        },
        {
          text: this.$i18n.tc('model.common.scope'),
          value: 'scope',
          sortable: false,
        },
        { text: this.$i18n.tc('model.user.lastlogin'), value: 'lastloginFromNow' },
        { text: this.$i18n.tc('model.common.state'), value: 'state' },
      ];
    },
  },

  data(): {
    users?: UserDisplayList[];
    search: string;
    inactive: boolean;
  } {
    return {
      users: undefined,
      search: '',
      inactive: false,
    };
  },

  async mounted() {
    try {
      this.users = await UserUtils.api.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async create() {
      await this.$router.push({ name: 'user-create' });
    },

    async edit(user: UserDisplayList) {
      await this.$router.push({
        name: 'user-edit',
        params: { id: `${user.id}` },
      });
    },

    async remove(user: UserDisplayList) {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [user.username])
          .toString(),
        async () => {
          if (user.id && this.users) {
            this.$alert.hide('remove');
            await UserUtils.api.remove(user.id);

            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [user.username],
              }),
            });

            const index = this.users.findIndex((val) => val.id === user.id);
            if (index >= 0) {
              this.users.splice(index, 1);
            }
          }
        }
      );
    },
  },
});
